var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "d-flex align-items-md-center justify-content-center font-size-14 py-1 px-2",
      class: [_vm.backgroundColor],
    },
    [
      _c("div", {
        staticClass: "icon font-size-20 pe-1 icon-vertical-center",
        class: [_vm.icon],
      }),
      _vm._v(" "),
      _c("div", [
        _c("strong", {
          attrs: { id: "headerBanner" },
          domProps: { innerHTML: _vm._s(_vm.label) },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }